// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemRoundGetBody = {
  poolId: string;
  roundId?: string | null;
};

export type typePickemRoundGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    round: {
      roundId: string;
      label: string;
      ordinal: number;
      status: "scheduled" | "open" | "locked" | "graded";
      startDate: string;
      endDate: string;
      firstLockAt?: string | null;
      lastLockAt?: string | null;
    };
    rules: {
      scoringFormat: "standard" | "confidence";
      picksRequiredMode: "all" | "count";
      picksRequiredCount?: number | null;
      pickBasis: "moneyline" | "spread";
      tiebreaker: "none" | "totalPoints";
      tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
      winPoints: number;
      lossPoints: number;
    };
    games: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      isLocked: boolean;
      locksAt: string;
      isPickable: boolean;
      unavailableReason?:
        "locked" | "postponed" | "canceled" | "beforeEntry" | null;
      liveScore?: { home: number; away: number } | null;
      spread?: { homeLine?: number | null; isPending: boolean } | null;
      isTiebreakerGame: boolean;
      myPick?: {
        teamId: string;
        side: "home" | "away";
        confidenceRank?: number | null;
        spreadLine?: number | null;
        acceptsPendingSpread: boolean;
        outcome: "win" | "loss" | "push" | "pending";
        points?: number | null;
        isLocked: boolean;
      } | null;
    }[];
    picksRequired: number;
    picksMade: number;
    picksStillNeeded: number;
    confidence: {
      maxRank: number;
      availableRanks: number[];
      lockedRanks: number[];
    } | null;
    tiebreaker: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      locksAt: string;
      isLocked: boolean;
      myGuess?: number | null;
    } | null;
    myScore: {
      status: "open" | "scored";
      points: number;
      wins: number;
      losses: number;
      pushes: number;
      missed: number;
      roundRank?: number | null;
      isRoundWinner: boolean;
    } | null;
    viewer: {
      entryId?: string | null;
      canPick: boolean;
      cannotPickReason?:
        "notEntered" | "roundNotOpen" | "roundLocked" | "contestEnded" | null;
    };
  };
};

export type typePickemRoundGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemRoundGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemRoundGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemRoundGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemRoundGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemRoundGetBody);
  }

  return async function postPickemRoundGet(
    payload: typePickemRoundGetBody,
  ): Promise<typePickemRoundGetOutput200 | typePickemRoundGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemRoundGet" failed before calling the network. #7a7c11b6fc78`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7a7c11b6fc78" },
        },
        data: null,
      } as typePickemRoundGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/round-get`,
      httpMethod: "POST",
      options,
    })) as typePickemRoundGetOutput200 | typePickemRoundGetOutput400;
  };
}
